import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  children: React.ReactNode;
  containerSelector?: string;
}

export default function Portal({
  children,
  containerSelector = 'body',
}: Props) {
  const [rootElement, setRootElement] = useState<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const container = document.querySelector(containerSelector);
    const root = document.createElement('div');
    container?.appendChild(root);
    setRootElement(root);
    return () => {
      container?.removeChild(root);
      setRootElement(null);
    };
  }, []);

  return rootElement ? createPortal(children, rootElement) : null;
}
